import React from 'react';

import { connect } from 'react-redux';

function UsersContainer(Component, params) {
    
    const mainContainer = (props) => {

        let [totalRecords, setTotalRecords] = React.useState(0);
        const [pagination, setPagination] = React.useState({
            page: 0,
            page_limit: 10,
        })

        
        const [order, setOrder] = React.useState({
            order_by: `${params.defaultOrderBy}`,
            direction: 'asc'
        })

        const getTotalCount = (count) =>{
            setTotalRecords(count);
        }

        React.useEffect(() => {
            setTotalRecords(props.totalReportRecord);
        }, [props.totalReportRecord]);

        const options = {
            tableId:'datatable',
            filterType: 'checkbox',
            search: false,
            responsive: "simple",
            filter: false,
            download: false,
            print: false,
            selectableRows: 'none',
            viewColumns: false,
            count: totalRecords,
            serverSide: (props.serverSide!==undefined)?props.serverSide:true,
            page: pagination.page,
            rowsPerPage: pagination.page_limit,
            onColumnSortChange: (changedColumn) => {
                setOrder({
                    order_by: changedColumn,
                    direction: (order.direction === 'asc') ? 'desc' : 'asc'
                })

            },
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        setPagination({
                            page_limit: pagination.page_limit,
                            page: tableState.page
                        })
                        break;
                    case 'changeRowsPerPage':
                        setPagination({
                            page_limit: tableState.rowsPerPage,
                            page: 0,
                        })
                        break;
                    default:
                        break
                }
            }
        };
        return (
            <Component getTotalCount={getTotalCount} options={options} columns={[]} pagination={pagination} order={order} />
        );
    }
    const mapStateToProps = (state) => ({
        totalRecord: (state.user && state.user.usersList && state.user.usersList.total_users) ? state.user.usersList.total_users : 0,
        totalReportRecord: (state.user && state.user.reportUsers && state.user.reportUsers.total_users) ? state.user.reportUsers.total_users : 0
    });

    return connect(mapStateToProps)(mainContainer);
}

export default UsersContainer;
